import React from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setGameConfig } from '../../store/actions'
import DIFFICULTIES from '../../config/Difficulties'
import { useTypedSelector } from '../../hooks'
import {
  Container,
  MenuContainer,
  MenuContent,
  AppName,
  DifficultyContainer,
  DifficultyLabelContainer,
  DifficultyLabelSubtitle,
  DifficultyLabelTitle,
  DifficultyLabel,
  Difficulty,
  PlayButton,
  PlayButtonContainer,
} from './styles'

const DifficultyChooser: React.FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const selectedDifficulty = useTypedSelector(
    ({ GameConfig }) => GameConfig.difficulty,
  )

  const onSelectDifficulty = (difficulty: number) => (): void => {
    const action = setGameConfig({ difficulty })
    dispatch(action)
  }

  const onPlay = (): void => {
    history.push('/oyun')
  }

  return (
    <Container>
      <MenuContainer>
        <AppName>Hafıza Oyunu</AppName>

        <MenuContent>
          <DifficultyLabelContainer>
            <DifficultyLabel>
              <DifficultyLabelTitle>Bir zorluk seç:</DifficultyLabelTitle>
              <DifficultyLabelSubtitle>
                Kartların altındaki sayılar oyundaki kart sayılarıdır.
              </DifficultyLabelSubtitle>
            </DifficultyLabel>
          </DifficultyLabelContainer>

          <DifficultyContainer>
            <Difficulty
              name="Çok Kolay"
              numOfCards={DIFFICULTIES.VEASY}
              onClick={onSelectDifficulty(DIFFICULTIES.VEASY)}
              isSelected={selectedDifficulty === DIFFICULTIES.VEASY}
            />
            <Difficulty
              name="Kolay"
              numOfCards={DIFFICULTIES.EASY}
              onClick={onSelectDifficulty(DIFFICULTIES.EASY)}
              isSelected={selectedDifficulty === DIFFICULTIES.EASY}
            />
            <Difficulty
              name="Orta"
              numOfCards={DIFFICULTIES.MEDIUM}
              onClick={onSelectDifficulty(DIFFICULTIES.MEDIUM)}
              isSelected={selectedDifficulty === DIFFICULTIES.MEDIUM}
            />
            <Difficulty
              name="Zor"
              numOfCards={DIFFICULTIES.HARD}
              onClick={onSelectDifficulty(DIFFICULTIES.HARD)}
              isSelected={selectedDifficulty === DIFFICULTIES.HARD}
            />
            <Difficulty
              name="Çok Zor"
              numOfCards={DIFFICULTIES.SHARD}
              onClick={onSelectDifficulty(DIFFICULTIES.SHARD)}
              isSelected={selectedDifficulty === DIFFICULTIES.SHARD}
            />
          </DifficultyContainer>

          <PlayButtonContainer>
            <PlayButton onClick={onPlay}>Oyuna Başla!</PlayButton>
          </PlayButtonContainer>
          
          <br/>
          <div className="footer">
    <p className="copyright">
        © 2022 All rights reserved. Made with 
         <span className="kalp"> ❤ </span> 
         by  
        <a href="https://slipyme.xyz" rel="noopener noreferrer" target="_blank" className="slipyme" title="Sevgiyle"> Slipyme </a>
        using
        <a href="https://tailwindcss.com/" rel="noopener noreferrer" target="_blank" className="tailwind"> TailwindCSS</a>.
        </p>
</div>
        </MenuContent>
      </MenuContainer>
    </Container>
  )
}

export default DifficultyChooser
